import { render, staticRenderFns } from "./BuyerOrderLogistics.vue?vue&type=template&id=477fba22&"
import script from "./BuyerOrderLogistics.vue?vue&type=script&lang=js&"
export * from "./BuyerOrderLogistics.vue?vue&type=script&lang=js&"
import style0 from "./BuyerOrderLogistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports